import { useWeb3React } from "@web3-react/core";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";

import { FaHandSparkles } from "react-icons/fa";
import { TbHandClick, TbHandFinger } from "react-icons/tb";

import {
    // followProfile,
    // getPostByLink,
    getPostsByTag,
    getPostsByType,
    likeArticle,
} from "../../utils/apis";
import { notify, showToast, walletConnectNotify } from "../../utils/hot-toast";

import LinkWithSearchParams from "../UI/LinkWithSearchParams";
import LoadingBar from "../UI/LoadingBar";
import { useStore } from "../../utils/store";
// import removeMarkdown from "markdown-to-text";
import { BiMessageSquareDetail } from "react-icons/bi";
import { BsReply } from "react-icons/bs";
import ProfileBadge from "../UI/ProfileBadge";
import { GiChainedHeart } from "react-icons/gi";
import MDEditor from "@uiw/react-md-editor";

const PostList = ({ type }) => {
    const { tag } = useParams();
    const { account } = useWeb3React();

    const profile = useStore((state) => state.profile);

    const [mainLoading, setMainLoading] = useState(false);
    const [posts, setPosts] = useState([]);
    const [authors, setAuthors] = useState([]);

    useEffect(() => {
        if (tag) loadPostsByTag();
        else if (type) loadPostsByType(type);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tag, type]);
    const loadPostsByTag = async () => {
        setMainLoading(true);
        const _posts = await getPostsByTag(tag);

        if (_posts) {
            setPosts(_posts);
            setMainLoading(false);
            return;
        } else setPosts([]);
        setMainLoading(false);
    };

    const loadPostsByType = async (type) => {
        // console.log("type", type);
        // if (!profile?.wallet) return;
        setMainLoading(true);
        const _posts = await getPostsByType(type, profile?.wallet);

        if (_posts?.articles) {
            setPosts(_posts?.articles);
            setAuthors(_posts?.authors);
            setMainLoading(false);
            return;
        } else setPosts([]);
        setMainLoading(false);
    };

    const likeToggleArticle = async (id) => {
        if (!account) {
            walletConnectNotify();
            return;
        }
        try {
            const _updatedPost = await likeArticle(id, account);
            setPosts(
                posts.map((post) =>
                    post._id !== _updatedPost._id ? post : _updatedPost
                )
            );
            if (_updatedPost.likes.includes(account)) {
                notify(
                    "success",
                    <FaHandSparkles className="w-16 h-16 animation-enter" />,
                    "Like Post!",
                    "Successfully clapped this article"
                );
                return;
            }
            showToast("info", "Successfully unclapped this article.", null);
        } catch (error) {
            showToast(
                "error",
                "Error occured while clapping article.",
                null,
                "Something went wrong!"
            );
        }
    };

    const getAuthor = (wallet) => {
        if (!authors) return null;
        return authors.find((author) => author.wallet === wallet);
    };

    return (
        <div className="flex flex-col animation-fade-in gap-6 py-6">
            {mainLoading ? (
                <LoadingBar />
            ) : (
                posts.length > 0 && (
                    <>
                        {posts
                            .filter((post) => !post.thread)
                            .map((post, index) => (
                                <div
                                    key={index}
                                    className="flex flex-col pt-4 pb-2 border-b-2 border-kadComponentBg"
                                >
                                    <div className="flex gap-4">
                                        <ProfileBadge
                                            profile={getAuthor(post.wallet)}
                                        />
                                        <div className="flex flex-col">
                                            <LinkWithSearchParams
                                                className="hover:opacity-70"
                                                to={{
                                                    pathname: `/profile/${
                                                        getAuthor(post.wallet)
                                                            ?.username
                                                    }`,
                                                }}
                                            >
                                                {
                                                    getAuthor(post.wallet)
                                                        ?.username
                                                }
                                            </LinkWithSearchParams>
                                            <span className="size-sm font-light opacity-70">
                                                {new Date(
                                                    post.createdAt
                                                ).toLocaleDateString(
                                                    "en-US",
                                                    {}
                                                )}
                                                {/*  {" · "}
                                                {Math.ceil(
                                                    post.markdown.length / 1000
                                                )}{" "}
                                                mins read */}
                                            </span>
                                        </div>

                                        {post.featured && (
                                            <LinkWithSearchParams
                                                to={{
                                                    pathname: `/feeds/featured`,
                                                }}
                                            >
                                                <GiChainedHeart
                                                    title="Featured Post"
                                                    className="size-2 mr-4 mt-2 duration-150 hover:fill-kadGrSt"
                                                />
                                            </LinkWithSearchParams>
                                        )}
                                    </div>
                                    {/* <div className="py-4 hover:opacity-70 duration-150 flex items-center">
                                        {post.featured && (
                                            <LinkWithSearchParams
                                                to={{
                                                    pathname: `/feeds/featured`,
                                                }}
                                            >
                                                <GiChainedHeart
                                                    title="Featured Post"
                                                    className="size-2 mr-4 duration-150 hover:fill-kadGrSt"
                                                />
                                            </LinkWithSearchParams>
                                        )}
                                        <LinkWithSearchParams
                                            to={{
                                                pathname: `/feeds/${post.link}`,
                                            }}
                                            className="size-1"
                                        >
                                            {post.subject}
                                        </LinkWithSearchParams>
                                    </div> */}

                                    <LinkWithSearchParams
                                        to={{
                                            pathname: `/feeds/${post.link}`,
                                        }}
                                        className="mt-4"
                                    >
                                        <MDEditor.Markdown
                                            source={post?.markdown}
                                            style={{
                                                background: "transparent",
                                            }}
                                        />

                                        {post?.giphyLink?.length > 0 && (
                                            <img
                                                alt="giphy attachment"
                                                src={post?.giphyLink}
                                                className="animation-enter w-full mt-4"
                                            />
                                        )}
                                    </LinkWithSearchParams>
                                    <div className="flex pt-4 items-center">
                                        {post.tags.map((tag, index) => (
                                            <LinkWithSearchParams
                                                key={index}
                                                className="article-tag mr-2"
                                                to={{
                                                    pathname: `/feeds/tag/${tag}`,
                                                }}
                                            >
                                                {tag}
                                            </LinkWithSearchParams>
                                        ))}
                                        {post.likes.includes(account) ? (
                                            <TbHandClick
                                                className="ml-auto mr-1 size-2 cursor-pointer hover:fill-transparent fill-kadGrSt duration-150"
                                                onClick={() =>
                                                    likeToggleArticle(post._id)
                                                }
                                            />
                                        ) : (
                                            <TbHandFinger
                                                className="ml-auto mr-1 size-2 cursor-pointer hover:stroke-kadGrSt duration-150"
                                                onClick={() =>
                                                    likeToggleArticle(post._id)
                                                }
                                            />
                                        )}
                                        <span>{post.likes.length}</span>

                                        <BiMessageSquareDetail className="ml-4 mr-1 size-2 cursor-pointer hover:fill-kadGrSt duration-150" />
                                        <span>{post.replyNumber}</span>

                                        <LinkWithSearchParams
                                            to={{
                                                pathname: `/feeds/${post.link}`,
                                            }}
                                        >
                                            <BsReply className="ml-4 mr-1 size-2 cursor-pointer hover:fill-kadGrSt duration-150" />
                                        </LinkWithSearchParams>
                                    </div>
                                </div>
                            ))}
                    </>
                )
            )}
        </div>
    );
};
export default PostList;
